import { Condition, Medication } from "../data/medication-condition-pairs";

const CONDITIONS_WITHOUT_SPECIAL_SITUATIONS: {
  condition: Condition;
  medication: Medication;
}[] = [
  {
    condition: Condition.HYPOPHOSPHATASIA,
    medication: Medication.STRENSIQ,
  },
];

export const shouldShowSpecialSituationsField = (
  medication: string,
  condition: string,
): boolean => {
  if (!medication || !condition) {
    return true;
  }

  return !CONDITIONS_WITHOUT_SPECIAL_SITUATIONS.some(
    (entry) => entry.condition === condition && entry.medication === medication,
  );
};
